// extracted by mini-css-extract-plugin
export default {"root":"AskList_root__3xQ5L","list":"AskList_list__CQt4T","pagination":"AskList_pagination__kau6i","emp":"AskList_emp__+7mV7"};